import unhangPrepositions from './utils/unhangPrepositions';

import i18n from './i18n';

const strings = {
  main: 'Главная',
  rating: 'Рейтинг участников ATI.SU',
  carrier: 'Перевозчик',
  forwarder: 'Экспедитор',
  shipper: 'Грузовладелец',
  dispatcher: 'Диспетчер',
  forwarderCarrier: 'Экспедитор-перевозчик',
  shipperCarrier: 'Грузовладелец-перевозчик',
  regulated: ['урегулированная претензия', 'урегулированные претензии', 'урегулированных претензий'],
  from: 'из',
  claims: ['претензии', 'претензий', 'претензий'],
  faq: 'Подробнее о рейтинге',
  title: 'Рейтинг перевозчиков, экспедиторов и\u00A0грузовладельцев',
  paragraph: 'Место зависит от выбранного региона (города), баллов в Паспорте участника и ещё более 10-ти параметров, которые держатся в тайне, чтобы не было накруток. Рейтинг обновляется ежедневно.',
  best: 'Лучшие',
  presents: 'получают сертификаты и награды',
  dot: '.',
  filter: 'Рейтинг',
  antiFilter: 'Антирейтинг',
  verifiedProfile: 'Соответствие профиля',
  autopark: 'Свои ТС',
  orders: 'Заказы на ATI.SU',
  atiDocs: 'АТИ-Доки',
  confirmedContacts: 'Контакт подтверждён',
  readyForEtrn: 'Готов к ЭТрН',
  showAllFilters: 'Все фильтры',
  hideFilters: 'Скрыть фильтры',
  notFound: 'Участники не найдены',
  clearFilter: 'Попробуйте изменить или очистить фильтр',
  filterButton: 'ОЧИСТИТЬ ФИЛЬТР',
  passport: 'Паспорт',
  recs: 'Рекомендации',
  claimsTitle: 'Задолженность',
  participants: ['участник', 'участника', 'участников'],
  customerRecs: 'Рекомендации как заказчику',
  executorRecs: 'Рекомендации как исполнителю',
  recommendationsCounter: ['рекомендация', 'рекомендации', 'рекомендаций'],
  confirmedProfileTooltip: 'По данным ATI.SU деятельность фирмы соответствует профилю',
  requestError: 'Произошла ошибка, повторите попытку позже',
  ball: ['балл', 'балла', 'баллов'],
  searchActiveTransporters: 'Поиск активных перевозчиков',
  getBadgeEtrn: 'Получите значок «Готов к ЭТрН»',
  useWhenWaitingLong: 'Используйте, если долго не уходит груз',
  standOutFromCompetition: 'и выделитесь среди конкурентов',
  getBadge: 'Получить значок',
  try: 'Попробовать',
  safetyBannerPrimary: 'ATI.SU о безопасности',
  safetyBannerSecondary: 'Свести риски к\u00A0минимуму и\u00A0не\u00A0попасть на\u00A0мошенников',
  safetyBannerBtn: 'Узнать',
  avgPriceBannerPrimary: 'Рыночная ставка по направлению — ваш аргумент в переговорах',
  avgPriceBannerBtn: 'Перейти в средние ставки',
  carrierTab: 'Перевозчики',
  dispatcherTab: 'Экспедиторы',
  shipperTab: 'Грузовладельцы',
  allDispatchers: 'Все экспедиторы',
  allShippers: 'Все грузовладельцы',
  participantsPerPage: 'Участников на странице',
  of: 'из',
  nextPageTip: 'Следующая страница',
  previousPageTip: 'Предыдущая страница',
  inputPageTip: 'Введите номер страницы и нажмите Ввод',
  seoDescription: 'Рейтинг транспортных компаний в России, Европе и странах СНГ по версии ATI.SU. Список топовых перевозчиков, экспедиторов и грузовладельцев с высокими оценками. Таблица с оценками и наградами.',
  seoTitle: 'Топ транспортных компаний — Рейтинг перевозчиков и экспедиторов',
  getRatingError: 'Произошла ошибка. Попробуйте обновить страницу или вернитесь позже.',
};

function makeLocizeHandlers() {
  return {
    get(target, prop) {
      const propValue = target[prop];

      if (!propValue || Array.isArray(propValue)) {
        return propValue;
      }

      return i18n.exists(prop) ? i18n.t(prop) : propValue;
    },
  };
}

const locize = () => (
  new Proxy(strings, makeLocizeHandlers())
);

export default unhangPrepositions(locize());
